import {EnterpriseEditionContext} from "components/src/context/EnterpriseEditionContextProvider";
import {useContext} from 'react'

export function useEnterpriseEditionContext()
{
    const context = useContext(EnterpriseEditionContext);

    if (!context) {
        throw new Error(
            "useEnterpriseEditionContext must be used within the scope of EnterpriseEditionContextProvider"
        );
    }

    return context;
}